import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PermissionState } from './permission.reducer';

export const selectPermissionState = createFeatureSelector<PermissionState>('permissions');

export const selectPermissions = createSelector(
  selectPermissionState,
  (state: PermissionState) => state.permissions
);

export const selectMyProfile = createSelector(
  selectPermissionState,
  (state: PermissionState) => state.myProfile
);

export const selectHeaderTitle = createSelector(
  selectPermissionState,
  (state: PermissionState) => state.headerTitle
);
 
export const hasPermissionKey = (moduleId: number, key: string) =>
  createSelector(
    selectPermissions,
    perms => !!perms[moduleId]?.[key]   // e.g., perms[1]['Create']
  );

export const getPermissionId = (moduleId: number, key: string) =>
  createSelector(
    selectPermissions,
    perms => perms[moduleId]?.[key] ?? null
  );
